import React from "react";
import { connect } from "react-redux";
import { Menu } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/logo.png";
import { ProgressBarPadrao } from "../../components/Base";

const { SubMenu } = Menu;

function Func(props) {
  const current = [];

  return (
    <div style={{ position: "fixed", width: "100%", zIndex: 950 }}>
      <Menu mode="horizontal" theme="dark" selectedKeys={current} style={{ padding: "0 20px" }} className="menu-principal">
        <Menu.Item key="Logo">
          <NavLink to="/inicio">
            <img style={{ maxHeight: 28 }} src={Logo} alt="logo" />
          </NavLink>
        </Menu.Item>

        {props.dados.tipo === 'adm' &&
          <SubMenu theme="light" title="Cadastro" popupClassName="submenu-light">
            <Menu.Item key="setting:1">
              <NavLink to="/cad/usu">Usuario</NavLink>
            </Menu.Item>
            <Menu.Item key="setting:2">
              <NavLink to="/cad/em">Empresa</NavLink>
            </Menu.Item>
            <SubMenu style={{ color: "#333" }} title="Características">
              <Menu.Item key="setting:1">
                <NavLink to="/cad/carac/segmento">Segmento</NavLink>
              </Menu.Item>
              <Menu.Item key="setting:2">
                <NavLink to="/cad/carac/fxFaturamento">Faixa de Faturamento</NavLink>
              </Menu.Item>
              <Menu.Item key="setting:3">
                <NavLink to="/cad/carac/portepdv">Porte do PDV</NavLink>
              </Menu.Item>
              <Menu.Item key="setting:4">
                <NavLink to="/cad/carac/modeloneg">Modelo de Negocio</NavLink>
              </Menu.Item>
              <Menu.Item key="setting:5">
                <NavLink to="/cad/carac/tipoemp">Tipo de Empresa</NavLink>
              </Menu.Item>
              <Menu.Item key="setting:6">
                <NavLink to="/cad/carac/perfil">Perfil</NavLink>
              </Menu.Item>
              <Menu.Item key="setting:7">
                <NavLink to="/cad/carac/rgComer">Região Comercial</NavLink>
              </Menu.Item>
              <Menu.Item key="setting:8">
                <NavLink to="/cad/carac/rgGeo">Região Geografica</NavLink>
              </Menu.Item>
              <Menu.Item key="setting:9">
                <NavLink to="/cad/carac/rede">Rede</NavLink>
              </Menu.Item>
              <Menu.Item key="setting:10">
                <NavLink to="/cad/carac/federacao">Federação</NavLink>
              </Menu.Item>
            </SubMenu>
            <Menu.Item key="setting:4">
              <NavLink to="/cad/fab">Fabricante</NavLink>
            </Menu.Item>
            <Menu.Item key="setting:5">
              <NavLink to="/cad/set">Setor</NavLink>
            </Menu.Item>
            <Menu.Item key="setting:6">
              <NavLink to="/cad/gru">Grupo</NavLink>
            </Menu.Item>
          </SubMenu>
        }

        {props.dados.tipo === 'adm' &&
          <SubMenu theme="light" title="Outros" popupClassName="submenu-light">
            <Menu.Item key="setting:1">
              <NavLink to="/outros/fabind">Fabricantes Indefinidos</NavLink>
            </Menu.Item>

          </SubMenu>
        }

        {props.dados.tipo === 'fabricante' &&
          <MenuItem txt="anlrepo" path={props.path}>
            <NavLink to="/anlrepo">Análise e reposição</NavLink>
          </MenuItem>
        }

        {props.dados.tipo === 'fabricante' &&
          <MenuItem txt="indicadores" path={props.path}>
            <NavLink to="/inicio">Indicadores</NavLink>
          </MenuItem>
        }

        {props.dados.tipo === 'fabricante' &&
          <MenuItem txt="ranking" path={props.path}>
            <NavLink to="/ranking">Ranking</NavLink>
          </MenuItem>
        }

        {props.dados.tipo === 'fabricante' &&
          <MenuItem txt="pwbi" path={props.path}>
            <NavLink to="/powerbi">Gestão de Categorias</NavLink>
          </MenuItem>
        }

        {props.dados.tipo === 'loja' &&
          <MenuItem txt="pwbi">
            <NavLink to="/powerbi/gc">Gestão de Categorias</NavLink>
          </MenuItem>
        }

        {props.dados.tipo === 'loja' &&
          <MenuItem txt="pwbi">
            <NavLink to="/powerbi/prc">Pricing</NavLink>
          </MenuItem>
        }



        <SubMenu style={{ float: "right" }} theme="light" title={<UserOutlined />} popupClassName="submenu-light">
          <Menu.Item key="setting:4">
            <NavLink to="/sair">Sair</NavLink>
          </Menu.Item>
        </SubMenu>
      </Menu>
      {props.loading && <ProgressBarPadrao />}
    </div>
  );
}

const mapStateToProps = state => {
  return { auth: state.auth, dados: state.dados };
};

export default connect(mapStateToProps, {})(Func);

function MenuItem({ txt, children, path, ...props }) {
  return (
    <>
      <Menu.Item key={txt} className={path === txt && "active"} {...props}>
        {children}
      </Menu.Item>
    </>
  );
}
